import { Check } from "lucide-react";
import { cn } from "@/lib/cn";

interface TypeCardProps {
    id: string;
    name: string;
    subtitle?: string | null;
    imageUrl?: string | null;
    selected: boolean;
    onClick: () => void;
}

export function TypeCard({
    name,
    subtitle,
    imageUrl,
    selected,
    onClick,
}: TypeCardProps) {
    return (
        <button
            type="button"
            data-testid="type-card"
            onClick={onClick}
            className={cn(
                "relative w-full rounded-2xl overflow-hidden aspect-3/4 transition-all duration-150 cursor-pointer",
                selected
                    ? "ring-4 ring-primary shadow-xl scale-[1.02]"
                    : "hover:shadow-md hover:scale-[1.01]",
            )}
        >
            <div className="absolute inset-0 bg-gray-200">
                {imageUrl && (
                    <img
                        src={imageUrl}
                        alt={name}
                        className="w-full h-full object-cover"
                    />
                )}
            </div>

            <div className="absolute inset-x-0 bottom-0 bg-linear-to-t from-black/70 via-black/40 to-transparent pt-20 pb-4 px-3">
                <p className="font-semibold text-white sm:text-sm leading-snug">
                    {name}
                </p>
                {subtitle && (
                    <p className="mt-0.5 text-xs text-white/80 line-clamp-2">
                        {subtitle}
                    </p>
                )}
            </div>

            {selected && (
                <div className="absolute inset-0 bg-primary/20 pointer-events-none" />
            )}

            {selected && (
                <div
                    data-testid="type-card-check"
                    className="absolute top-2 right-2 size-9 rounded-full bg-primary flex items-center justify-center shadow-lg"
                >
                    <Check className="size-5 text-contrast-text" />
                </div>
            )}
        </button>
    );
}
